<template>
  <DialogHeader>
    <div
      class="size-[30px] rounded-full bg-red-200/50 flex items-center justify-center mr-2.5"
    >
      <Icon name="Alert" :size="16" class="stroke-red-700" />
    </div>
    <div>{{ title }}</div>
  </DialogHeader>
  <DialogContent>
    <div class="mb-3">
      Are you sure you want to archive
      <span class="font-medium">{{ filesCopy }}</span> from Dacr?
    </div>
    <div>
      By archiving, you will lose your Dacr copyright protection history. You
      will not be able to recover
      {{ pluralize('this copyright', files.length) }} once it is archived.
    </div>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-full tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton danger class="w-full tablet-h:w-auto" @click="handleClick">
      Archive
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { Icon, UiButton } from '@dacr/ui'
import type { File } from '@/shared/graphql/router/graphql'
import { computed } from 'vue'
import pluralize from 'pluralize'

const { close, open } = useDialog()

const props = defineProps<{
  files: File[]
}>()

const title = computed(() => {
  if (props.files.length === 1) return 'Archive copyright?'
  return 'Archive copyrights?'
})

const filesCopy = computed(() => {
  if (props.files.length === 1) return props.files[0].name
  return `${props.files.length} copyrights`
})

const handleClick = () => {
  open(Dialogs.ConfirmArchiveFiles, {
    props: { files: props.files },
  })
}
</script>
